const SHIFT_SWAP_NAVIGATION_ROOTS = ['/roster/shift-swaps', '/me/shift-swaps'] as const;

/**
 * Keep every discovery surface aligned with the server-enforced shift_swaps
 * switch. The switch only removes links; route layouts and RPCs remain the
 * authoritative direct-navigation/write boundaries.
 */
export function isShiftSwapNavigationPathVisible(
  href: string,
  shiftSwapsEnabled: boolean | null | undefined,
): boolean {
  if (shiftSwapsEnabled === true) return true;
  const pathname = href.split(/[?#]/, 1)[0] || href;
  return !SHIFT_SWAP_NAVIGATION_ROOTS.some(
    (root) => pathname === root || pathname.startsWith(`${root}/`),
  );
}

export function filterShiftSwapNavigationItems<T extends { href: string }>(
  items: readonly T[],
  shiftSwapsEnabled: boolean | null | undefined,
): T[] {
  return items.filter((item) => isShiftSwapNavigationPathVisible(item.href, shiftSwapsEnabled));
}
